import React from 'react';
import { Show, SimpleShowLayout, TextField } from 'react-admin';

const EstadoValicionShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="descripcion" />
    </SimpleShowLayout>
  </Show>
);

export default EstadoValicionShow;
